import { render, staticRenderFns } from "./RequestsLayout.vue?vue&type=template&id=1178f285&scoped=true&"
import script from "./RequestsLayout.vue?vue&type=script&lang=js&"
export * from "./RequestsLayout.vue?vue&type=script&lang=js&"
import style0 from "./RequestsLayout.vue?vue&type=style&index=0&id=1178f285&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178f285",
  null
  
)

export default component.exports